import React from "react"
import Button from "aldoo-ra/Button"
import Localization from "aldoo-ra/Localization"

const BlogCategories = ({ categories = [], onItemClick, selectedCategory }) => {
  const { currentLanguage } = Localization()

  const handleCategoryClick = (category) => {
    if (onItemClick) {
      const newCategory =
        selectedCategory?._id === category._id ? null : category
      onItemClick(newCategory)

      // Build URL with language prefix
      const langPrefix = currentLanguage && currentLanguage !== 'en' ? `/${currentLanguage}` : ''

      if (newCategory) {
        window.history.replaceState(
          {},
          "",
          `${langPrefix}/blog?category=${encodeURIComponent(newCategory.title)}`
        )
      } else {
        window.history.replaceState({}, "", `${langPrefix}/blog`)
      }
    }
  }

  return (
    <div className="w-full flex flex-row gap-4 lg:gap-5 xl:gap-7">
      {categories.map((category, index) => {
        const isSelected =
          selectedCategory && category._id === selectedCategory._id

        return (
          <Button
            variant={isSelected ? "primary_s" : "secondary_s"}
            className="flex-shrink-0"
            onClick={() => handleCategoryClick(category)}
            key={category._id || index}
          >
            {category.title}
          </Button>
        )
      })}
    </div>
  )
}

export default BlogCategories
